module.exports = __webpack_public_path__ + "img/avatar.30f3b8f3.jpg";